import { useCallback, useRef } from 'react';


export function useDebouncedAbortableFetch(delay = 300) {
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);
  const controller = useRef<AbortController | null>(null);

  const debounced = useCallback(
    (term: string, fn: (t: string, s: AbortSignal) => void) => {
      if (timer.current) clearTimeout(timer.current);
      controller.current?.abort();                    

      controller.current = new AbortController();
      timer.current = setTimeout(() => {
        fn(term, controller.current!.signal);         
      }, delay);
    },
    [delay]
  );

  return debounced;
}
